<div class="content">
  <button mat-icon-button class="close-button bg-transparent" mat-dialog-close>
    <mat-icon aria-hidden="false">close</mat-icon>
  </button>
  <div class="text-center mat-dialog-title">Csoportok kezelése</div>

  <div *ngIf="selectedGroup !== null; then groupdetails; else grouplist"></div>
  <ng-template #grouplist>
    <button mat-flat-button class="mt-3 w-100" color="primary" (click)="newGroup()">
      <mat-icon>add</mat-icon>
      Csoport létrehozása
    </button>
    <div class="flex-column my-2 group-list">
      <div class="flex-center flex-column">
        <button
          mat-flat-button
          class="group-item"
          *ngFor="let group of groups$ | async"
          (click)="getGroup(group.id)"
        >
          {{ group?.name }}
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #groupdetails>
    <div>
      <div *ngIf="!edit" class="flex-row align-center fix-height">
        <div class="group-name">{{ selectedGroup.name }}</div>
        <button mat-icon-button class="ml-4 edit" (click)="edit = true">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button class="delete" (click)="deleteGroup()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <div *ngIf="edit" class="flex-row fix-height">
        <mat-form-field class="col-6" appearance="outline">
          <input
            matInput
            type="text"
            [ngModel]="selectedGroup.name"
            (ngModelChange)="name = $event"
          />
        </mat-form-field>
        <button mat-icon-button class="done" (click)="renameGroup()">
          <mat-icon>done</mat-icon>
        </button>
        <button mat-icon-button class="delete" (click)="edit = false">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="aircrafts my-2 flex">
      <div *ngIf="dataSource.data?.length > 0; then aircrafts; else noAircraft"></div>
      <ng-template #aircrafts>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="beaconType">
            <th mat-header-cell *matHeaderCellDef>JeladóT.</th>
            <td mat-cell *matCellDef="let aircraft">{{ aircraft.beaconType.toString() }}</td>
          </ng-container>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>JeladóID</th>
            <td mat-cell *matCellDef="let aircraft">{{ aircraft.deviceId }}</td>
          </ng-container>
          <ng-container matColumnDef="aircraftType">
            <th mat-header-cell *matHeaderCellDef>LégijárműT.</th>
            <td mat-cell *matCellDef="let aircraft">{{ aircraft.aircraftType }}</td>
          </ng-container>
          <ng-container matColumnDef="registrationNumber">
            <th mat-header-cell *matHeaderCellDef>Lajstrom</th>
            <td mat-cell *matCellDef="let aircraft">{{ aircraft.registrationNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="remove">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let aircraft">
              <mat-icon class="delete vertical-center" (click)="removeAircraft(aircraft)"
              >delete
              </mat-icon>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
        </table>
      </ng-template>
      <ng-template #noAircraft>
        <div class="center vertical-center">Még nincs hozzáadott jeladó</div>
      </ng-template>
    </div>
    <div class="flex-row flex-space-between">
      <div class="vertical-center">Jeladó azonosítója:</div>
      <mat-form-field class="col-4" appearance="outline">
        <input type="text" matInput [formControl]="id" [matAutocomplete]="auto" />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option.deviceId">
            {{ option.deviceId }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <button class="add-button" mat-flat-button color="primary" (click)="addAircraft()">
        <mat-icon>add</mat-icon>
        Hozzáad
      </button>
    </div>
    <button class="mt-4" mat-flat-button color="primary" (click)="selectedGroup = null">
      Vissza
    </button>
  </ng-template>
</div>
